import actions from "./Actions";
const { GET_Api_DATA, GET_Api_DATA_LOAD, VIDEO_DOWNLOADER, GET_Api_DATA_ERROR, CHANGE_THEME } = actions;
const reducer = (state: any, actions: { payload: any; type: string }) => {
  switch (actions?.type) {
    case CHANGE_THEME:
      localStorage.setItem(
        "theme", state.theme ? "false" : "true"
      )
      return { ...state, theme: state.theme !== true };
    case GET_Api_DATA:
      return { ...state, urlReturnData: actions.payload, loading: false };
    case VIDEO_DOWNLOADER:
      return { ...state, videoData: actions.payload, loading: false };
    case GET_Api_DATA_LOAD:
      return { ...state, loading: actions.payload };
    case GET_Api_DATA_ERROR:
      return { ...state, loading: actions.payload, urlReturnData: null };
    default:
      return state;
  }
};
export default reducer;
